import { useContext } from 'react';

import ArtlistDataContext from '@/context/ArtlistDataContext';
import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';

import VirtualList from './components/VirtualList';

import './index.css';

export default function ArtlistBody({ cacheKey, setOpenAddArtworks }) {
  const { artlistData, isCreator } = useContext(ArtlistDataContext);
  const t = useTranslations('common.profile.pages.artlist');
  const artworks = artlistData.artlist_artworks ?? [];
  const totalArtworks = artlistData.artlist_artworks_total ?? artworks.length;

  return (
    totalArtworks === 0 ? (
      <div className="artlist-content__empty">
        <p className="artlist-content__empty-text">
          {isCreator
            ? t('empty.creator.description')
            : t('empty.visitor.description', {
              name: artlistData.artlist_creator?.user_username,
            })}
        </p>

        {isCreator && (
          <ContinueButton className="artlist-content__empty-button" onClick={() => setOpenAddArtworks(true)}>
            {t('empty.creator.actions.add_artworks')}
          </ContinueButton>
        )}
      </div>
    ) : (
      <VirtualList items={artlistData} cacheKey={cacheKey} />
    )
  );
}
